module.exports = __webpack_public_path__ + "static/media/proj1_img2.83e8e911.jpg";